<template>
  <div class="messaging-view">
    {{ caseId }}
  </div>
</template>
<script>
  export default {
    name: 'messaging-view-component',
    props: {
      caseId: {
      }
    }
  }
</script>
